import Auth from './auth';
import Assets from './assets';
import Coins from './coins';
import Orders from './orders';
import Rates from './rates';
import Forecasts from './forecasts';
import Moderation from './moderation';
import Ui from './ui';

export default {
  Auth,
  Assets,
  Coins,
  Orders,
  Rates,
  Moderation,
  Ui,
  Forecasts
}



// WEBPACK FOOTER //
// ./src/services/index.js